import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "map-wrapper" }
const _hoisted_2 = { class: "controls-left" }
const _hoisted_3 = { class: "colorscale" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"gradient\"><div style=\"height:20%;width:100%;background:linear-gradient(to top, #7E0023, #3F0000);\"></div><div style=\"height:30%;width:100%;background:linear-gradient(to top, #99004C, #7E0023);\"></div><div style=\"height:15%;width:100%;background:linear-gradient(to top, #FF0000, #99004C);\"></div><div style=\"height:11%;width:100%;background:linear-gradient(to top, #FF7E00, #FF0000);\"></div><div style=\"height:9%;width:100%;background:linear-gradient(to top, #FFFF00, #FF7E00);\"></div><div style=\"height:10%;width:100%;background:linear-gradient(to top, #00E400, #FFFF00);\"></div><div style=\"height:5%;width:100%;background:linear-gradient(to top, #21998F, #00E400);\"></div></div>", 1)
const _hoisted_5 = { class: "tooltips" }
const _hoisted_6 = ["data-tooltip"]
const _hoisted_7 = ["data-tooltip"]
const _hoisted_8 = ["data-tooltip"]
const _hoisted_9 = ["data-tooltip"]
const _hoisted_10 = ["data-tooltip"]
const _hoisted_11 = ["data-tooltip"]
const _hoisted_12 = ["data-tooltip"]
const _hoisted_13 = ["data-tooltip"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-information-outline" }, null, -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "controls-right" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-home-map-marker" }, null, -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PollutionLayerHyperLocalManager = _resolveComponent("PollutionLayerHyperLocalManager")!
  const _component_PollutionLayerStationManager = _resolveComponent("PollutionLayerStationManager")!
  const _component_InformationModal = _resolveComponent("InformationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{'is-invisible': !_ctx.ready}, "map"]),
      ref: "map"
    }, null, 2 /* CLASS */),
    (_ctx.ready)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hyperlocals, (location) => {
            return (_openBlock(), _createBlock(_component_PollutionLayerHyperLocalManager, {
              map: _ctx.map,
              key: location.location_name,
              location: location
            }, null, 8 /* PROPS */, ["map", "location"]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createVNode(_component_PollutionLayerStationManager, {
            map: _ctx.map,
            stations: _ctx.stations,
            currentStation: _ctx.currentStation
          }, null, 8 /* PROPS */, ["map", "stations", "currentStation"])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "has-tooltip-right",
            "data-tooltip": _ctx.$t('dashboard.aqi.very_unhealthy'),
            style: {"height":"20%","width":"100%"}
          }, null, 8 /* PROPS */, _hoisted_6),
          _createElementVNode("div", {
            class: "has-tooltip-right",
            "data-tooltip": _ctx.$t('dashboard.aqi.very_unhealthy'),
            style: {"height":"30%","width":"100%"}
          }, null, 8 /* PROPS */, _hoisted_7),
          _createElementVNode("div", {
            class: "has-tooltip-right",
            "data-tooltip": _ctx.$t('dashboard.aqi.unhealthy'),
            style: {"height":"15%","width":"100%"}
          }, null, 8 /* PROPS */, _hoisted_8),
          _createElementVNode("div", {
            class: "has-tooltip-right",
            "data-tooltip": _ctx.$t('dashboard.aqi.moderate'),
            style: {"height":"11%","width":"100%"}
          }, null, 8 /* PROPS */, _hoisted_9),
          _createElementVNode("div", {
            class: "has-tooltip-right",
            "data-tooltip": _ctx.$t('dashboard.aqi.good'),
            style: {"height":"9%","width":"100%"}
          }, null, 8 /* PROPS */, _hoisted_10),
          _createElementVNode("div", {
            class: "has-tooltip-right",
            "data-tooltip": _ctx.$t('dashboard.aqi.very_good'),
            style: {"height":"10%","width":"100%"}
          }, null, 8 /* PROPS */, _hoisted_11),
          _createElementVNode("div", {
            class: "has-tooltip-right",
            "data-tooltip": _ctx.$t('dashboard.aqi.very_good'),
            style: {"height":"5%","width":"100%"}
          }, null, 8 /* PROPS */, _hoisted_12)
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openInformation && _ctx.openInformation(...args))),
        class: "info button is-rounded is-link has-tooltip-right",
        "data-tooltip": _ctx.$t('map.information.tooltip')
      }, _hoisted_15, 8 /* PROPS */, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "info button is-rounded is-link",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fitBounds()))
      }, _hoisted_18)
    ]),
    _createVNode(_component_InformationModal, { ref: "infoModal" }, null, 512 /* NEED_PATCH */)
  ]))
}